import React, {Component} from "react";
import '../EMR.css';
import ActiveDiagnosisTab from "./ActiveDiagnosisTab";
import Risk from "./Risk";
import TextareaInput from "../../../../components/textarea-input/TextareaInput";
import InsuranceStatus from "./InsuranceStatus";
import ProcedureTables from "./ProcedureTables";
import RemotingService from "../../../../services/remoting-service/RemotingService";
import RedAsterisk from "../../../../components/asterisk/RedAsterisk";
import VisitNavigator from "../common/VisitNavigator";

export default class Diagnosis extends Component {

    constructor(props) {
        super(props);
        this.state = {
            index: props.currentVisitIndex
        };
    }

    componentDidMount() {
        this.retrieveInsuranceApprovalForVisit();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.currentVisit.id !== this.props.currentVisit.id) {
            this.setState({index: this.props.currentVisitIndex});
            this.retrieveInsuranceApprovalForVisit();
        }
        if (prevState.index !== this.state.index) {
            this.retrieveInsuranceApprovalForVisit();
        }
    }

    retrieveInsuranceApprovalForVisit = () => {
        const selectedVisit = this.props.visits[this.state.index];
        RemotingService.getRemoteCall(
            'api/insurance/coordinator/visit',
            {visitId: selectedVisit.id},
            (insuranceApproval) => {
                this.setState({insuranceApproval});
            });
    }

    render() {
        const selectedVisit = this.props.visits[this.state.index];
        const selectedDiagnosis = selectedVisit.diagnosis;
        const currentVisit = this.props.visits[this.props.currentVisitIndex];
        const currentDiagnosis = currentVisit.diagnosis;
        const isDirectBilling = this.state.insuranceApproval && 'DIRECT_BILLING' === this.state.insuranceApproval?.insuranceRecord?.type;

        return (
            <div>
                <VisitNavigator
                    visits={this.props.visits}
                    currentVisitIndex={this.props.currentVisitIndex}
                    selectedIndex={this.state.index}
                    onDateChange={(index) => {
                        this.setState({index: index});
                    }}
                />
                <div className={this.props.disabled ? "content-row disable-pointer" : "content-row"}>
                    <div className={"content-col-6"}>
                        <div className={"content-wrapper"}>
                            <ActiveDiagnosisTab diagnosis={currentDiagnosis}
                                                visits={this.props.visits}
                                                isDirectBilling={isDirectBilling}
                                                currentVisitIndex={this.props.currentVisitIndex}
                                                selectedVisitIndex={this.state.index}
                                                disabled={this.props.disabled}/>
                            <br/>
                            <br/>
                            <br/>

                            <div>
                                <div className="content-label">Clinical Impression <RedAsterisk renderForAllTypes/>
                                </div>
                                <TextareaInput value={currentDiagnosis.clinicalImpression || ''}
                                               placeholder={"Clinical Impression"}
                                               onChange={value => {
                                                   currentDiagnosis.clinicalImpression = value;
                                                   this.forceUpdate();
                                               }}
                                               autoHeight
                                               maxLength={5000}
                                               style={{width: "100%"}}
                                />
                            </div>
                            <Risk diagnosis={currentDiagnosis}/>
                        </div>
                    </div>

                    <div className={"content-col-6"}>
                        <div className={"content-wrapper"}>
                            <div className="content-label">Billing</div>
                            <InsuranceStatus diagnosis={currentDiagnosis}
                                             insuranceApproval={this.state.insuranceApproval}
                                             currentVisit={currentVisit}/>
                            <br/>
                            <br/>
                            <ProcedureTables diagnosis={currentDiagnosis}
                                             insurance={this.props.insurance}
                                             currentVisit={currentVisit}/>
                            <br/>
                            <br/>
                            <br/>

                            <div>
                                <div className="content-label">Note to Cashier</div>
                                <TextareaInput value={currentDiagnosis.noteToCashier || ''}
                                               placeholder={"Note to Cashier"}
                                               onChange={value => {
                                                   currentDiagnosis.noteToCashier = value;
                                                   this.forceUpdate();
                                               }}
                                               maxLength={1024}
                                               style={{width: "100%"}}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
